import { Popover, Table } from "antd";
import { useMemo } from "react";
import { When } from "react-if";
import HBIcon from "../HBIcon";
import styles from "./index.module.less";

export function VipInfoAuth({
  data,
}: {
  data: {
    tableHeader: {
      key: string;
      title: string;
    }[];
    authService: {
      desc: string;
      enterpriseAdvanced: string;
      enterpriseMajor: string;
      enterpriseStandard: string;
      personal: string;
      personalNoAuth: string;
    }[];
  };
}) {
  const moreTableColumns = useMemo(() => {
    const render = (text: string, record: any) => {
      return (
        <div className={styles.content}>
          <div className={styles.text}>{text}</div>
          <When condition={record.tip}>
            <Popover
              content={
                <div
                  className={styles.tipText}
                  dangerouslySetInnerHTML={{
                    __html: record.tip,
                  }}
                ></div>
              }
              overlayStyle={{ width: 217 }}
              placement="top"
            >
              <HBIcon className={styles.icon} type="ic_help" />
            </Popover>
          </When>
        </div>
      );
    };

    const columns = data.tableHeader.map((item: any) => {
      return {
        ...item,
        dataIndex: item.key,
        width: +item.moreWidth || 236,
        render,
      };
    });

    return [
      {
        title: "授权服务",
        dataIndex: "desc",
        key: "desc",
        width: 236,
        render: (text: string) => {
          return (
            <div className={styles.content}>
              <div className={styles.text}>{text}</div>
            </div>
          );
        },
      },
      ...columns,
    ];
  }, [data]);

  return (
    <div className={styles.auth} id="discoveryRange">
      <div className={styles.more}>
        <div className={styles.head}>
          {moreTableColumns.map((column, index) => (
            <div className={styles.col} key={index}>
              {column.title}
            </div>
          ))}
        </div>
        <Table
          className={styles.table}
          rowKey="id"
          dataSource={data?.authService}
          columns={moreTableColumns}
          pagination={false}
          showHeader={false}
        />
      </div>
    </div>
  );
}
